import React from 'react';

interface ErrorMessageProps {
  message?: string;
  show?: boolean;
  id?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  message, 
  show = true,
  id
}) => {
  if (!message || !show) return null;

  return (
    <span id={id} className="ui-input__error" role="alert" aria-live="polite">
      {message}
    </span>
  );
};
